/**
 * FieldGraphDebugToggle — show/hide the synthetic airfield network overlay
 * (runway, taxiway spine, gates, and routed taxi polylines). Demo aid on the
 * event-planner page; pairs with the Top-down camera toggle.
 */
import { Share2 } from 'lucide-react'
import { ToolbarButton } from './ToolbarButton'

interface FieldGraphDebugToggleProps {
  active: boolean
  onToggle: () => void
  fullWidth?: boolean
}

export function FieldGraphDebugToggle({ active, onToggle, fullWidth }: FieldGraphDebugToggleProps) {
  return (
    <ToolbarButton
      icon={<Share2 className="h-4 w-4" />}
      label="Graph"
      accent="emerald"
      active={active}
      fullWidth={fullWidth}
      onClick={onToggle}
      title="Toggle field-graph overlay (runway, spine, taxi routes)"
    />
  )
}
